document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('filter-form');

    if (form) {
        form.addEventListener('change', function () {
            form.submit();
        });
    }
});